import React, { useEffect, useMemo, useState } from 'react';
import { Modal, Input, Spin, message } from 'antd';
import { useSelector } from 'react-redux';
import squareCatalogApi from '../../../services/squareCatalogApi';

// level: 'product' → choose an ITEM; 'item' → choose an ITEM_VARIATION;
// 'option' → choose a MODIFIER. Variations/modifiers are children in the DTO.
const PosMappingPickerModal = ({ open, level, onClose, onSelect }) => {
  const globalCompany = useSelector((state) => state.companyReducer.selected);
  const [objects, setObjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');

  useEffect(() => {
    if (!open || !globalCompany?.id) return;
    (async () => {
      try {
        setLoading(true);
        const type = level === 'option' ? 'MODIFIER_LIST' : 'ITEM';
        const res = await squareCatalogApi.objects(globalCompany.id, type);
        setObjects(res.data.data || []);
      } catch (err) {
        message.error('Could not load the Square catalog');
        setObjects([]);
      } finally {
        setLoading(false);
      }
    })();
  }, [open, level, globalCompany?.id]);

  const rows = useMemo(() => {
    const all = [];
    objects.forEach((parent) => {
      if (level === 'product') {
        all.push({ id: parent.id, name: parent.name, hint: null });
      } else {
        (parent.children || []).forEach((child) =>
          all.push({ id: child.id, name: child.name, hint: parent.name })
        );
      }
    });
    const q = search.trim().toLowerCase();
    return q
      ? all.filter(
          (r) =>
            r.name.toLowerCase().includes(q) ||
            (r.hint || '').toLowerCase().includes(q)
        )
      : all;
  }, [objects, level, search]);

  return (
    <Modal open={open} onCancel={onClose} footer={null} title="Select Square POS item">
      <Input
        placeholder="Search Square catalog"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="mb-3"
      />
      {loading ? (
        <div className="py-8 text-center"><Spin /></div>
      ) : (
        <div className="max-h-80 space-y-1 overflow-y-auto">
          {rows.map((row) => (
            <button
              key={row.id}
              type="button"
              onClick={() => {
                onSelect(row.id, row.name);
                onClose();
              }}
              className="flex w-full items-center justify-between rounded-md border border-slate-200 px-3 py-2 text-left text-sm hover:bg-slate-50 dark:border-slate-600 dark:hover:bg-slate-700"
            >
              <span>{row.name}</span>
              {row.hint && (
                <span className="text-xs text-slate-400">{row.hint}</span>
              )}
            </button>
          ))}
          {rows.length === 0 && (
            <p className="py-6 text-center text-sm text-slate-400">
              No matching Square objects
            </p>
          )}
        </div>
      )}
    </Modal>
  );
};

export default PosMappingPickerModal;
